export default {
    wait() {
    },

    done(html) {
        const select = $('#athlete_subscription_athlete');
        const button = $('#cCard-OrderSubscribe__SubmitAthleteSelection');

        $('#cCard-OrderSubscribe__AthleteSelected').html(html);

        if (select.val()) {
          button.removeAttr('disabled');
        } else {
          button.attr('disabled', true);
        }
    },

    fail() {
    }
}



// WEBPACK FOOTER //
// ./assets/js/component/ajax/checkout-athlete-data.js